export class Result{

  urlGetList      : string;
  urlGetSingle    : string;
  urlSave         : string;
  listFieldName   : string;
  entityFieldName : string;

  
    constructor(urlGetList : string, urlGetSingle : string,  urlSave : string, listFieldName : string, entityFieldName : string){
      this.urlGetList     = urlGetList;
      this.urlGetSingle   = urlGetSingle;
      this.urlSave        = urlSave;
      this.listFieldName  = listFieldName;
      this.entityFieldName = entityFieldName;
    }
  }
  